angular.module('jv.Dashboard.Kpi.Controller', [])
.controller('jv.Dashboard.Kpi.Controller', ['$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService', '$timeout','$rootScope', '$filter', 'jvSearchUrlRedirectService',
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $timeout,$rootScope, $filter, jvSearchUrlRedirectService) {
    var widgetObject = $scope.widgetObject;
    var sourceType, duration = 30, userValue;
    $scope.source = '';
    var todaysDate = $rootScope.fetchTodayInUsersTimeZone();
    $scope.refreshTimestamp = true;
    var fetchDateBasedOnOffset = function(offset) {
        var userTimeZone = _jvselfUser.locale.timezone;
        var momentObject = moment().tz(userTimeZone);

        if (offset < 0) {
            momentObject = moment(momentObject).subtract(offset*-1, 'days');
        } else {
            momentObject = moment(momentObject).add(offset, 'days');
        }

        var offsetDate = momentObject.toDate();
        return offsetDate;
    };

    //Period1 is the current time range.
    var period1StartDate = fetchDateBasedOnOffset(duration*-1);
    var period1EndDate = todaysDate;
    
    //Used for clickable metrics number
    $scope.timeInterval = {
        startDate: period1StartDate,
        endDate: period1EndDate,
        period2StartDate: period2StartDate,
        period2EndDate: period2EndDate
    };

    $scope.getStartDate = function(){
        return $filter('date')($scope.timeInterval.startDate, 'yyyy-MM-dd');
    };

    $scope.getEndDate = function(){
        return $filter('date')($scope.timeInterval.endDate, 'yyyy-MM-dd');
        
    };

    $scope.goToNewCandidateSearch = function() {
        jvSearchUrlRedirectService.setSourceId($scope.source, function(){
            jvSearchUrlRedirectService.setApplicationDate($scope.timeInterval.startDate, $scope.timeInterval.endDate);
            jvSearchUrlRedirectService.setRequisitionType(4); // my open reqs
            jvSearchUrlRedirectService.redirect();
        });
    };

    //Period2 is the previous time range. 
    var period2StartDate = fetchDateBasedOnOffset(duration*-2);
    var period2EndDate = fetchDateBasedOnOffset(duration*-1);
    
    var init = function(refreshWidget){
        var widgetSettings = $scope.widgetObject.userWidgetSettings.widgetSetting;
        angular.forEach(widgetSettings,function(settingsObject,key){
            if(settingsObject.userValues){
                 userValue = settingsObject.userValues[0];
                if(userValue.label && angular.isObject(userValue.label)){
                    userValue.label = angular.copy(userValue.label.name);
                    userValue.value = angular.copy(userValue.label);
                    delete userValue.name;
                }
                sourceType = userValue.value;
                $scope.source = userValue.label;
            }else{
                sourceType = settingsObject.settings.defaultValues[0].value;
                $scope.source = settingsObject.settings.defaultValues[0].label;
                }
        });
        getApplicationCounts(refreshWidget);
    };

    //Handler for refresh_widget
    $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
        if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
            $scope.refreshTimestamp = false;
            $scope.lastUpdated = '';
            init(true);
        }
    });
    var getApplicationCounts = function(refresh) {
        $scope.data = {};
        jvDashboardAjaxService.getSourceMetrics({
            'sourceIds': sourceType,
            'period1StartDate' : $filter('date')(period1StartDate, 'yyyy-MM-dd'),
            'period1EndDate' : $filter('date')(period1EndDate, 'yyyy-MM-dd'),
            'period2StartDate' : $filter('date')(period2StartDate, 'yyyy-MM-dd'),
            'period2EndDate' : $filter('date')(period2EndDate, 'yyyy-MM-dd'),
            'refresh' : refresh
        }, function(response) {
            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
            $scope.refreshTimestamp = true;
            $scope.lastUpdated = response.lastUpdated;
            var period1 = response.period1;
            var period2 = response.period2;
            $scope.data.high = (period1 > period2);
            $scope.data.count = period1;
            if (period2 === 0) {
                if (period1 === 0) {
                    $scope.data.percentage = 0;
                } else {
                   $scope.data.percentage = 100;
                }
            } else {
                if (period1 > period2) {
                    $scope.data.percentage = Math.ceil((period1 - period2)*100/period2);
                } else if (period1 < period2) {
                    $scope.data.percentage = Math.ceil((period2 - period1)*100/period2);
                } else {
                    $scope.data.percentage = 0;
                }
            }
            if ($scope.data.percentage > 100) {
                $scope.data.percentage = 100;
            }
            $scope.data.duration = duration;
        });
    };
    init();

}]);
